import React from 'react';
import { useLoyalty } from 'hooks';

import Como from './Como';
import Aura from './Aura';

interface Props {
  value?: string;
  onChange: Function;
}

const RedeemPoints: React.FC<Props> = ({ value, onChange }) => {
  const { user, type } = useLoyalty();

  if (!user) {
    return <></>;
  }

  if (type === 'como') {
    return <Como value={value} onChange={onChange} user={user} />;
  }

  if (type === 'aura') {
    return <Aura value={value} onChange={onChange} user={user} />;
  }

  return <div>Unknown Loyalty Partner</div>;
};

export default RedeemPoints;
